<template>
  <svg
    class="upload-icon"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :style="{ color }"
    viewBox="0 0 17 16"
    fill="none">
    <path
      class="upload-icon__path"
      d="M6.30927 5.13928L7.83594 3.60595V9.99928C7.83594 10.1761 7.90618 10.3457 8.0312 10.4707C8.15622 10.5957 8.32579 10.6659 8.5026 10.6659C8.67941 10.6659 8.84898 10.5957 8.97401 10.4707C9.09903 10.3457 9.16927 10.1761 9.16927 9.99928V3.60595L10.6959 5.13928C10.7579 5.20177 10.8316 5.25136 10.9129 5.28521C10.9941 5.31905 11.0813 5.33648 11.1693 5.33648C11.2573 5.33648 11.3444 5.31905 11.4257 5.28521C11.5069 5.25136 11.5806 5.20177 11.6426 5.13928C11.7051 5.0773 11.7547 5.00357 11.7885 4.92233C11.8224 4.84109 11.8398 4.75395 11.8398 4.66595C11.8398 4.57794 11.8224 4.4908 11.7885 4.40956C11.7547 4.32832 11.7051 4.25459 11.6426 4.19261L8.97594 1.52595C8.91253 1.46525 8.83777 1.41768 8.75594 1.38595C8.59363 1.31927 8.41158 1.31927 8.24927 1.38595C8.16744 1.41768 8.09267 1.46525 8.02927 1.52595L5.3626 4.19261C5.30044 4.25477 5.25114 4.32857 5.2175 4.40978C5.18386 4.491 5.16654 4.57804 5.16654 4.66595C5.16654 4.75385 5.18386 4.8409 5.2175 4.92211C5.25114 5.00333 5.30044 5.07712 5.3626 5.13928C5.42476 5.20144 5.49856 5.25075 5.57977 5.28439C5.66099 5.31803 5.74803 5.33534 5.83594 5.33534C5.92384 5.33534 6.01089 5.31803 6.0921 5.28439C6.17332 5.25075 6.24711 5.20144 6.30927 5.13928ZM14.5026 7.99928C14.3258 7.99928 14.1562 8.06952 14.0312 8.19454C13.9062 8.31957 13.8359 8.48914 13.8359 8.66595V12.6659C13.8359 12.8428 13.7657 13.0123 13.6407 13.1374C13.5157 13.2624 13.3461 13.3326 13.1693 13.3326H3.83594C3.65913 13.3326 3.48956 13.2624 3.36453 13.1374C3.23951 13.0123 3.16927 12.8428 3.16927 12.6659V8.66595C3.16927 8.48914 3.09903 8.31957 2.97401 8.19454C2.84898 8.06952 2.67942 7.99928 2.5026 7.99928C2.32579 7.99928 2.15622 8.06952 2.0312 8.19454C1.90618 8.31957 1.83594 8.48914 1.83594 8.66595V12.6659C1.83594 13.1964 2.04665 13.7051 2.42172 14.0802C2.7968 14.4552 3.3055 14.6659 3.83594 14.6659H13.1693C13.6997 14.6659 14.2084 14.4552 14.5835 14.0802C14.9586 13.7051 15.1693 13.1964 15.1693 12.6659V8.66595C15.1693 8.48914 15.099 8.31957 14.974 8.19454C14.849 8.06952 14.6794 7.99928 14.5026 7.99928Z" />
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: String,
      default: '20px',
    },
    color: {
      type: String,
      default: 'var(--landing-text-color, var(--bs-primary))',
    },
  });
</script>

<style lang="scss" scoped>
  .upload-icon__path {
    fill: currentColor;
  }
</style>
